import { Alert } from '@creditornot/cb-alert';
import { AlertCircleFilled } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Tag } from '@creditornot/cb-tag';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { typographyCss } from 'common/typography';
import { localize } from 'common/utils';
import { TextWithHighlightedMatches } from 'modules/experience-core';

import { CampaignVenueSelectItem } from './types';

export type VenueRowItemProps = {
  venueSelectItem: CampaignVenueSelectItem;
  searchValue?: string;
};

const VenueName = styled.div`
  ${typographyCss.Body3};
`;
const Address = styled.div`
  ${typographyCss.Small};
  color: ${cbSemanticCssVars.textSecondary};
`;

const Root = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-grow: 1;
  align-items: center;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const VenueRowItem = ({ venueSelectItem, searchValue = '' }: VenueRowItemProps) => {
  const { locale } = useIntl();

  const { name, address, city, post_code, information, warningTag } = venueSelectItem;

  return (
    <Root>
      <Content>
        <VenueName>
          <TextWithHighlightedMatches text={localize(name, locale) || '-'} searchValue={searchValue} />
        </VenueName>
        <Address>
          <TextWithHighlightedMatches text={`${address.trim()}, ${post_code} ${city}`} searchValue={searchValue} />
        </Address>
        {!!information && (
          <Alert variant="info" size="small">
            {information}
          </Alert>
        )}
      </Content>
      {!!warningTag && (
        <Tag variant="lightYellow" size="small" icon={<AlertCircleFilled />}>
          {warningTag}
        </Tag>
      )}
    </Root>
  );
};
